export const TYPE = {
  LINE: "line",
  SHAPE: "shape",
  ARROW: "arrow",
  NOTE: "note",
  SIGNATURE: "signature"
};

export const TYPE_LIST = {
  THUMB: "thumbnail",
  SIGNATURE: "signature"
};

export const STYLE = {
  COLOR: "#FF0000",
  FONT_FAMILY: "Roboto",
  FONT_SIZE: {
    SMALL: {
      id: 1,
      label: "Cỡ chữ nhỏ",
      value: 14
    },
    MEDIUM: {
      id: 2,
      label: "Cỡ chữ trung bình",
      value: 18
    },
    LARGE: {
      id: 3,
      label: "Cỡ chữ lớn",
      value: 22
    }
  },
  LIST_COLOR: [
    "#ff4500",
    "#ff8c00",
    "#ffd700",
    "#90ee90",
    "#00ced1",
    "#1e90ff",
    "#c71585",
    "#c7158577"
  ]
};

export const TYPE_STYLE = {};



// WEBPACK FOOTER //
// ./src/views/common/noteDocs/const-shape.js